import Metadata from './metadata';
export default function getCountries(metadata) {
  return new Metadata(metadata).getCountries();
}
//# sourceMappingURL=getCountries.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/libphonenumber-js/es6/getCountries.js
// module id = 1198
// module chunks = 0